// Tabla con repeticiones
import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
//import { ProductService } from './service/ProductService';

export default function MoveTheTableRep( {data}) {
    const [products, setProducts] = useState([]);


    //var data = []

    useEffect(() => {
        //ProductService.getProductsMini().then(data => setProducts(data));
    }, []);

    return (
        <div className="card">
            
            <DataTable stripedRows value={data} tableStyle={{ minWidth: '50rem' }}>
                <Column field="numtel" header="NumTel"></Column>
                <Column field="c" header="Repeticiones"></Column>
                <Column field="nombrebaseactual" header="NombreBaseTelcel"></Column>
                        
            </DataTable>
        </div>
    )

}